import { AssignedTicketsApi, CompletedTicketsApi, PendingTicketsApi } from "../model/FetchTicketApiAdmin";

export function PendingTickets(ticketFilterData,currentPage,currentdata){
    let url = `/getpendingtickets?page=${currentPage}`

        const params = new URLSearchParams();
        if (ticketFilterData) {
                if (ticketFilterData.ticketHeading) {
                        params.append("heading", ticketFilterData.ticketHeading);
                }

                if (ticketFilterData.ticketTool) {
                        params.append("tool", ticketFilterData.ticketTool);
                }
                if (ticketFilterData.ticketType) {
                        params.append("type", ticketFilterData.ticketType);
                }

                if (ticketFilterData.ticketId) {
                        params.append("id", ticketFilterData.ticketId);
                }

                if (ticketFilterData.ticketDate) {
                        params.append("date", ticketFilterData.ticketDate);
                }
                if (ticketFilterData.ticketStatus) {
                        params.append("status", ticketFilterData.ticketStatus);
                }

                if (params.toString()) {
                        url += `&${params.toString()}`;
                }
        }
        console.log(url);
    let response = PendingTicketsApi(url)
    // console.log(response);
    return response
}
export function CompletedTickets(ticketFilterData,currentPage,currentdata){
    let url = `/getcompletedtickets?page=${currentPage}`

        const params = new URLSearchParams();
        if (ticketFilterData) {
                if (ticketFilterData.ticketHeading) {
                        params.append("heading", ticketFilterData.ticketHeading);
                }

                if (ticketFilterData.ticketTool) {
                        params.append("tool", ticketFilterData.ticketTool);
                }
                if (ticketFilterData.ticketType) {
                        params.append("type", ticketFilterData.ticketType);
                }

                if (ticketFilterData.ticketId) {
                        params.append("id", ticketFilterData.ticketId);
                }

                if (ticketFilterData.ticketDate) {
                        params.append("date", ticketFilterData.ticketDate);
                }
                if (ticketFilterData.ticketStatus) {
                        params.append("status", ticketFilterData.ticketStatus);
                }

                if (params.toString()) {
                        url += `&${params.toString()}`;
                }
        }
        console.log(url);



    let response = CompletedTicketsApi(url)
    // console.log(response);
    return response
}
export function AssignedTickets(ticketFilterData,currentPage,currentdata){

    // "/ticket-tool/getassignedtickets"
    let url = `/getassignedtickets?page=${currentPage}`

        const params = new URLSearchParams();
        if (ticketFilterData) {
                if (ticketFilterData.ticketHeading) {
                        params.append("heading", ticketFilterData.ticketHeading);
                }

                if (ticketFilterData.ticketTool) {
                        params.append("tool", ticketFilterData.ticketTool);
                }
                if (ticketFilterData.ticketType) {
                        params.append("type", ticketFilterData.ticketType);
                }

                if (ticketFilterData.ticketId) {
                        params.append("id", ticketFilterData.ticketId);
                }

                if (ticketFilterData.ticketDate) {
                        params.append("date", ticketFilterData.ticketDate);
                }
                if (ticketFilterData.ticketStatus) {
                        params.append("status", ticketFilterData.ticketStatus);
                }

                if (params.toString()) {
                        url += `&${params.toString()}`;
                }
        }
        console.log(url);
    let response = AssignedTicketsApi(url)
    // console.log("assigne tickets in vm");
    // console.log(response);
    return response
}